import { loading, error, success } from 'State/actions';

import * as types from './types';

import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import { dispatch } from 'Pages/importstudents/state/actions';

export const fetchReport = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_LOADING, true));
      const response = await MPWWebApi.postDownloadFileAsIs(
        'Export/NewYork/Sirs/FetchReport',
        'SIRS.csv',
        model,
        FileDownloadTypes.CSV
      );
      dispatch(
        success(types.NEW_YORK_SIRS_EXPORT_SET_REPORT_HAS_DATA, response)
      );
    } catch (e) {
      dispatch(error(types.NEW_YORK_SIRS_EXPORT_ERROR, e));
    } finally {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_LOADING, false));
    }
  };
};

export const clearErrors = () => {
  return dispatch(success(types.NEW_YORK_SIRS_EXPORT_CLEAR_ERROR, null));
};

export const clearReportHasData = () => {
  return {
    type: types.NEW_YORK_SIRS_EXPORT_SET_REPORT_HAS_DATA,
    payload: true,
  };
};

// Auto Export Actions

export const getAutoExportConfig = (exportId) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_CONFIG_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `Export/NewYork/Sirs/Exports/${exportId}`
      );
      dispatch(
        success(
          types.NEW_YORK_SIRS_EXPORT_GET_EXPORT_CONFIG,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(error(types.NEW_YORK_SIRS_EXPORT_ERROR, ex));
    } finally {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_CONFIG_LOADING, false));
    }
  };
};

export const setAutoExportConfig = (formValues) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_CONFIG_LOADING, true));

      await MPWWebApi.postGenericInsertUpdate(
        `Export/NewYork/Sirs/Exports`,
        formValues
      );
      dispatch(
        success(types.NEW_YORK_SIRS_EXPORT_SET_EXPORT_CONFIG, formValues)
      );
    } catch (ex) {
      dispatch(error(types.NEW_YORK_SIRS_EXPORT_ERROR, ex));
    } finally {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_CONFIG_LOADING, false));
    }
  };
};

export const updateConfigDidSave = (value) => {
  return {
    type: types.NEW_YORK_SIRS_EXPORT_SET_CONFIG_DID_SAVE,
    payload: value,
  };
};

export const fetchSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_LOADING, true));

      const response = await MPWWebApi.getGeneric('SiteMaster');

      dispatch(
        success(types.NEW_YORK_SIRS_EXPORT_GET_SITES, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.NEW_YORK_SIRS_EXPORT_ERROR, ex));
    } finally {
      dispatch(loading(types.NEW_YORK_SIRS_EXPORT_LOADING, false));
    }
  };
};

export const resetConfig = () => {
  return {
    type: types.NEW_YORK_SIRS_EXPORT_RESET_EXPORT_CONFIG,
  };
};



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/export/actions.js